import React from 'react';

import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuthCredentials } from '@hrlogics/react-auth';

import { appRoutes } from '@clearverify/constants';

import { getIsPathMatchLocation } from 'src/utils/router';

export const AuthOutletWrap: React.FC = () => {
  const location = useLocation();

  const { isAuthorized } = useAuthCredentials();

  const isRouteWithDisabledRedirect = React.useMemo(() => {
    return ROUTES_WITH_DISABLED_REDIRECT.some(route => getIsPathMatchLocation(location, route));
  }, [location]);

  if (isAuthorized && !isRouteWithDisabledRedirect) {
    return <Navigate to={appRoutes.root} />;
  }

  return <Outlet />;
};

const ROUTES_WITH_DISABLED_REDIRECT = [
  appRoutes.auth.logout,
  appRoutes.auth.setupMfa,
  appRoutes.auth.setupPaymentMethods,
];
